import { DataGrid } from "@mui/x-data-grid";
import React from "react";
import ManagementToolbar from "../managementShared/ManagementToolbar";
import Box from "@mui/material/Box";
import { useDeleteTeamMutation, useFetchTeamsQuery } from "../../../store";
import { columns } from "./utils/column";
import {
  CONFIRM_DIALOG,
  TEAM_DIALOG,
} from "../../../store/slices/utils/dialogEnum";
import { useDispatch, useSelector } from "react-redux";
import { setTeam } from "../../../store/slices/applicationManagement/managementSlice";
import {
  closeDialog,
  openDialog,
} from "../../../store/slices/dialog/dialogSlice";
import {
  openErrorToast,
  openSuccessToast,
} from "../../../store/slices/toast/toastSlice";
import CustomConfirmDialog from "../../../components/shared/CustomConfirmDialog";
import TeamForm from "./component/TeamForm";

const Teams = () => {
  const dispatch = useDispatch();
  const { team } = useSelector((state) => state.managementSlice);
  const { teamDialogOpen } = useSelector((state) => state.dialogSlice);
  const { data: teams, isLoading: teamsLoading } = useFetchTeamsQuery();
  const [deleteTeam, { isLoading: deleteTeamLoading }] =
    useDeleteTeamMutation();

  const handleUpdate = (team) => {
    dispatch(setTeam(team));
    dispatch(openDialog(TEAM_DIALOG));
  };

  const handleDelete = (team) => {
    dispatch(setTeam(team));
    dispatch(openDialog(CONFIRM_DIALOG));
  };

  const closeDelete = () => {
    dispatch(setTeam(null));
    dispatch(closeDialog(CONFIRM_DIALOG));
  };

  const postDelete = () => {
    deleteTeam(team.id).then((res) => {
      if (res) {
        if (!res.data.isSuccess) {
          dispatch(openErrorToast(res.data.message));
        } else {
          dispatch(openSuccessToast("İşlem Tamamlandı"));
          closeDelete();
        }
      }
    });
  };

  return (
    <Box
      sx={{
        height: 500,
        width: "100%",
        marginTop: 10,
        overflowX: "auto",
        minWidth: { xs: 600, sm: 0 },
        flex: "flex",
        flexDirection: "column",
      }}
    >
      {
        <CustomConfirmDialog
          handleConfirm={postDelete}
          title="Takım Silme Onayı"
          text="Bu takımı silmek istediğinize emin misiniz?"
          isLoading={deleteTeamLoading}
          handleClose={closeDelete}
        />
      }
      {teamDialogOpen && <TeamForm />}
      <DataGrid
        rows={teams?.data || []}
        loading={teamsLoading}
        disableColumnMenu
        columns={columns(handleUpdate, handleDelete)}
        pageSizeOptions={[5, 10, 25, 50]}
        disableRowSelectionOnClick
        slots={{
          toolbar: (props) => (
            <ManagementToolbar {...props} dialogType={TEAM_DIALOG} />
          ),
        }}
        showToolbar
      />
    </Box>
  );
};

export default Teams;
